import app from 'flarum/forum/app';
app.initializers.add('val-ui-numeric-tag-route', () => {
  const originalCurrentTag = app.currentTag;
  if (typeof originalCurrentTag !== 'function') return;

  /*
   * Les IDs numériques déjà chargés complètement.
   * Important : IndexPage appelle currentTag(true) à chaque redraw.
   * Il ne faut donc surtout pas interpréter ce "true" comme une
   * demande de refaire la requête à chaque rendu.
   */
  const loaded = new Set();
  const loading = new Set();
  app.currentTag = function (reload) {
    let raw = '';
    try {
      raw = String(this.search?.state?.params?.().tags || '');
    } catch (_) {}

    /*
     * Route normale avec slug : Flarum garde son comportement natif.
     */
    if (!/^\d+$/.test(raw)) {
      return originalCurrentTag.call(this, reload);
    }
    const tag = this.store?.getById?.('tags', raw);

    /*
     * Déjà chargé une fois : retour immédiat.
     * Même si Flarum nous appelle avec reload=true.
     */
    if (loaded.has(raw) && tag) {
      this.currentActiveTag = tag;
      return tag;
    }

    /*
     * Une requête est déjà en cours : ne pas en lancer une autre.
     */
    if (loading.has(raw)) {
      if (tag) {
        this.currentActiveTag = tag;
        return tag;
      }
      return this.currentActiveTag;
    }
    loading.add(raw);
    this.store.find('tags', raw, {
      include: 'children,children.parent,parent'
    }).then(() => {
      loaded.add(raw);
      const loadedTag = this.store?.getById?.('tags', raw);
      if (loadedTag) {
        this.currentActiveTag = loadedTag;
      }
      m.redraw();
    }).catch(() => {
      // Autoriser une nouvelle tentative ultérieure en cas d'échec.
      loaded.delete(raw);
    }).finally(() => {
      loading.delete(raw);
    });

    /*
     * Le modèle peut déjà être préchargé : on peut l'afficher tout de suite
     * pendant que la requête unique complète ses relations.
     */
    if (tag) {
      this.currentActiveTag = tag;
      return tag;
    }
    return;
  };
}, -100);